<template>
    <el-form :inline="true" class="demo-form-inline">
          <el-form-item label="企业名称：">
              <el-input v-model="formInline.entName" placeholder="请输入企业名称"></el-input>
          </el-form-item>
          <el-form-item label="是否统计：">
              <el-select style="width: 200px;" v-model="formInline.statistics" filterable placeholder="请选择">
                  <el-option
                  v-for="item in typeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                  </el-option>
              </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="search()">搜索</el-button>
            <el-button type="primary" @click="showAdd()">新建</el-button>
            <!-- <el-button type="primary">导出</el-button> -->
          </el-form-item>
      </el-form>
      <el-table class="table_wrapper" :data="tableData" :header-cell-style="{'text-align':'left'}" :cell-style="{'text-align':'left'}">
        <el-table-column label="ID" width="80">
          <template #default="scope">
            <div>
              <span>{{scope.row.id}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="企业名称" width="240" show-overflow-tooltip>
          <template #default="scope">
            <div>
              <span>{{ scope.row.entName }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="付费类型" width="150">
          <template #default="scope">
            <div>
              <span>{{ modeFilter(scope.row.billingMode) }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="企业用户数" width="240">
          <template #default="scope">
            <div>
              <span>{{ scope.row.userCount }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="是否统计" width="100">
          <template #default="scope">
            <div>
              <span>{{ statisticsFilter(scope.row.statistics) }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="联系电话" width="150">
          <template #default="scope">
            <div>
              <span>{{ scope.row.contactPhone || '--' }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="企业地址" show-overflow-tooltip>
          <template #default="scope">
            <div>
              <span>{{ scope.row.address || '--' }}</span>
            </div>
          </template>
        </el-table-column>
        
        <el-table-column label="操作" width="240" fixed="right">
          <template #default="scope">
            <el-button size="small" @click="handleEdit(scope.$index, scope.row)">
              编辑
            </el-button>
            <el-button type="success" size="small" @click="showDrawer(scope.$index, scope.row)">
              查看详情
            </el-button>
            <el-button
              size="small"
              type="danger"
              @click="handleDelete(scope.$index, scope.row)"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <Pagination
          v-model:current-page="currentPage"
          v-model:page-size="pageSize"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
      />

      <!-- 对话框--删除 -->
      <el-dialog
        v-model="centerDialogVisible"
        title="提示"
        width="500"
        align-center
      >
        <span>确定删除该企业？</span>
        <template #footer>
          <div class="dialog-footer">
            <el-button @click="centerDialogVisible = false">取消</el-button>
            <el-button type="primary" @click="deleteEnterprise()">确定</el-button>
          </div>
        </template>
      </el-dialog>
  
      <!-- 对话框--新建、编辑组织 -->
      <el-dialog v-model="dialogFormVisible" :title="dialogTitle" width="500" :close-on-click-modal="false" @closed="$refs.enterpriseFormRef?.clearValidate()">
          <el-form ref="enterpriseFormRef" label-position="right" label-width="auto" :model="addInfo" :rules="enterpriseRules">
          <el-form-item label="企业名称" prop="entName">
            <el-input v-model="addInfo.entName" autocomplete="off" placeholder="请输入企业名称" />
          </el-form-item>
          <el-form-item label="统一社会信用代码" prop="creditCode">
            <el-input v-model="addInfo.creditCode" autocomplete="off" placeholder="请输入统一社会信用代码" />
          </el-form-item>
          <el-form-item label="法人代表" prop="legalPerson">
            <el-input v-model="addInfo.legalPerson" autocomplete="off" placeholder="请输入法人代表" />
          </el-form-item>
          <el-form-item label="计费模式" prop="billingMode">
            <el-select v-model="addInfo.billingMode" placeholder="请选择">
              <el-option
                  v-for="item in billingModeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否统计" prop="statistics">
            <el-radio-group v-model="addInfo.statistics">
              <el-radio :label=1>是</el-radio>
              <el-radio :label=0>否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="联系电话" prop="contactPhone">
            <el-input v-model="addInfo.contactPhone" autocomplete="off" placeholder="请输入联系电话" />
          </el-form-item>
          <el-form-item label="企业地址" prop="address">
            <el-input v-model="addInfo.address" autocomplete="off" placeholder="请输入企业地址" />
          </el-form-item>
          </el-form>
          <template #footer>
          <div class="dialog-footer">
              <el-button @click="dialogFormVisible = false">取消</el-button>
              <el-button type="primary" @click="saveInfo()">确定</el-button>
          </div>
          </template>
      </el-dialog>

      <!-- 企业详情 -->
      <el-drawer
          v-model="drawer"
          :title="drawerTitle"
          direction="rtl"
          size="80%"
      >
        <el-tabs v-model="activeState" class="demo-tabs" @tab-change="handleClick">
          <el-tab-pane label="基本信息" :name="0">
            <el-form :model="detailData" label-position="right" label-width="auto">
              <el-row>
                  <el-col :span="12">
                      <el-form-item label="企业名称：" prop="">
                          <div>{{detailData.entName}}</div>
                      </el-form-item>
                  </el-col>
                  <el-col :span="12">
                      <el-form-item label="统一社会信用代码：" prop="">
                          <div>{{detailData.creditCode || '--'}}</div>
                      </el-form-item>
                  </el-col>
              </el-row>
              <el-row>
                  <el-col :span="12">
                      <el-form-item label="法人代表：" prop="">
                          <div>{{detailData.legalPerson || '--'}}</div>
                      </el-form-item>
                  </el-col>
                  <el-col :span="12">
                      <el-form-item label="付费类型：" prop="">
                          <div>
                          <span>{{modeFilter(detailData.billingMode) || '--'}}</span>
                          </div>
                      </el-form-item>
                  </el-col>
              </el-row>
              <el-row>
                  <el-col :span="12">
                      <el-form-item label="联系电话：" prop="">
                          <div>{{detailData.contactPhone || '--'}}</div>
                      </el-form-item>
                  </el-col>
                  <el-col :span="12">
                      <el-form-item label="企业地址：" prop="">
                          <div>{{detailData.address}}</div>
                      </el-form-item>
                  </el-col>
              </el-row>
              <el-row>
                  <el-col :span="12">
                      <el-form-item label="累计消费金额(元)：" prop="">
                          <div>{{detailData.usedAmount || '--'}}</div>
                      </el-form-item>
                  </el-col>
                  <el-col :span="12">
                      <el-form-item label="是否统计：" prop="">
                          <div>
                          <span>{{statisticsFilter(detailData.statistics) || '--'}}</span>
                          </div>
                      </el-form-item>
                  </el-col>
              </el-row>
            </el-form>
          </el-tab-pane>
          <el-tab-pane label="用户列表" :name="1">
            <!-- 新增按钮 -->
            <el-row style="margin-bottom: 10px;">
              <el-button type="primary" @click="addUser()">新增用户</el-button>
            </el-row>
            <el-table class="table_wrapper" :data="enterpriseUserList" :header-cell-style="{'text-align':'left'}" :cell-style="{'text-align':'left'}">
              <el-table-column label="ID" width="80">
                <template #default="scope">
                  <div>
                    <span>{{scope.row.id}}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="姓名" width="120">
                <template #default="scope">
                  <div>
                    <span>{{scope.row.name}}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="登录名" width="120" show-overflow-tooltip>
                <template #default="scope">
                  <div>
                    <span>{{scope.row.loginName}}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="手机号" width="120">
                <template #default="scope">
                  <div>
                    <span>{{scope.row.phoneNumber}}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="账户余额(元)" width="120">
                <template #default="scope">
                  <div>
                    <span>{{scope.row.balance || '--'}}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="车牌号">
                <template #default="scope">
                  <div>
                    <span>{{scope.row.licensePlate || '--'}}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="注册时间" width="150">
                <template #default="scope">
                  <div>
                    <span>{{scope.row.createTime || '--'}}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="120" fixed="right">
                <template #default="scope">
                  <el-button
                    size="small"
                    type="danger"
                    @click="handleUnbind(scope.$index, scope.row)"
                  >
                    解绑
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
            <!-- 分页 -->
            <Pagination
                v-model:current-page="currentPage2"
                v-model:page-size="pageSize2"
                :total="total2"
                @size-change="handleSizeChange2"
                @current-change="handleCurrentChange2"
            />
          </el-tab-pane>
          <el-tab-pane label="账单" :name="2">
            <el-row style="margin-bottom: 10px;">
              <el-form-item label="交易时间：">
                  <el-date-picker
                      v-model="tradeTime"
                      value-format="YYYY-MM-DD HH:mm:ss"
                      type="datetimerange"
                      range-separator="至"
                      start-placeholder="开始时间"
                      end-placeholder="结束时间"
                  />
              </el-form-item>
              <el-button style="margin-left: 30px;" type="primary" @click="getBillList(true)">搜索</el-button>
            </el-row>
            <el-table class="table_wrapper" :data="billList" :header-cell-style="{'text-align':'left'}" :cell-style="{'text-align':'left'}">
              <el-table-column label="用户名称" width="150">
                <template #default="scope">
                  <div>
                    <span>{{scope.row.userName || '--'}}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="平台订单号" width="200" show-overflow-tooltip>
                <template #default="scope">
                  <div>
                    <span>{{scope.row.recordId || '--'}}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="充电订单编号" width="300" show-overflow-tooltip>
                <template #default="scope">
                  <div>
                    <span>{{scope.row.transactionId || '--'}}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="交易时间" width="200">
                <template #default="scope">
                  <div>
                    <span>{{scope.row.tradeTime || '--'}}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="交易金额" width="120">
                <template #default="scope">
                  <div>
                    <span>{{scope.row.tradeAmt || '--'}}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="支付类型" width="150">
                <template #default="scope">
                  <div>
                    <span>{{scope.row.payTypeStr || '--'}}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="交易类型" width="120">
                <template #default="scope">
                  <div>
                    <span>{{scope.row.tradeTypeStr || '--'}}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="交易状态" width="120">
                <template #default="scope">
                  <div>
                    <span>{{scope.row.tradeStatusStr || '--'}}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="累计消费金额(元)">
                <template #default="scope">
                  <div>
                    <span>{{scope.row.consumerAmt || '--'}}</span>
                  </div>
                </template>
              </el-table-column>
            </el-table>
            <!-- 分页 -->
            <Pagination
                v-model:current-page="currentPage3"
                v-model:page-size="pageSize3"
                :total="total3"
                @size-change="handleSizeChange3"
                @current-change="handleCurrentChange3"
            />
          </el-tab-pane>
          <el-tab-pane label="充电记录" :name="3">
            <el-row style="margin-bottom: 10px;">
              <el-form-item label="充电时间：">
                <el-radio-group v-model="chargeFormInline.dateType" style="margin-right: 10px;">
                  <el-radio :label=1>充电开始时间</el-radio>
                  <el-radio :label=2>充电结束时间</el-radio>
                </el-radio-group>
                  <el-date-picker
                      v-model="chargeFormInline.chargeRecordTime"
                      value-format="YYYY-MM-DD HH:mm:ss"
                      type="datetimerange"
                      range-separator="至"
                      start-placeholder="开始时间"
                      end-placeholder="结束时间"
                  />
              </el-form-item>
              <el-form-item label="手机号：" style="margin-left: 20px;">
                  <el-input v-model="chargeFormInline.phoneNumber" placeholder="请输入手机号" />
              </el-form-item>
              <el-form-item label="交易号：" style="margin-left: 20px;">
                  <el-input v-model="chargeFormInline.transactionId" placeholder="请输入交易号" />
              </el-form-item>
              <el-button style="margin-left: 30px;" type="primary" @click="getChargeRecordList(true)">搜索</el-button>
            </el-row>
            <el-table class="table_wrapper" :data="chargeRecordList" :header-cell-style="{'text-align':'left'}" :cell-style="{'text-align':'left'}">
              <el-table-column label="手机号" width="150">
                <template #default="scope">
                  <div>
                    <span>{{scope.row.phoneNumber || '--'}}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="交易号" width="280">
                <template #default="scope">
                  <div>
                    <span>{{scope.row.transactionId || '--'}}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="车牌号" width="100">
                <template #default="scope">
                  <div>
                    <span>{{scope.row.license || '--'}}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="充电状态" width="200">
                <template #default="scope">
                  <div>
                    <span>{{scope.row.chargeState || '--'}}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="充电开始时间" width="200">
                <template #default="scope">
                  <div>
                    <span>{{scope.row.beginTime || '--'}}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="充电结束时间" width="200">
                <template #default="scope">
                  <div>
                    <span>{{scope.row.endTime || '--'}}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="充电量(度)">
                <template #default="scope">
                  <div>
                    <span>{{scope.row.chargeQuantity || '--'}}</span>
                  </div>
                </template>
              </el-table-column>
            </el-table>
            <!-- 分页 -->
            <Pagination
                v-model:current-page="currentPage4"
                v-model:page-size="pageSize4"
                :total="total4"
                @size-change="handleSizeChange4"
                @current-change="handleCurrentChange4"
            />
          </el-tab-pane>
        </el-tabs>
      </el-drawer>

      <!-- 对话框--解绑 -->
      <el-dialog
        v-model="unbindDialog"
        title="提示"
        width="500"
        align-center
      >
        <span>确定解绑该用户？</span>
        <template #footer>
          <div class="dialog-footer">
            <el-button @click="unbindDialog = false">取消</el-button>
            <el-button type="primary" @click="unbindEnterprise()">确定</el-button>
          </div>
        </template>
      </el-dialog>
  
      <!-- 新增用户弹窗 -->
      <el-dialog v-model="dialogFormUser" title="新增用户" width="500" :close-on-click-modal="false" @closed="$refs.userFormRef?.clearValidate()">
          <el-form ref="userFormRef" label-position="right" label-width="auto" :model="userFormData" :rules="userRules">
            <el-form-item label="姓名" prop="name">
              <el-input
                v-model="userFormData.name"
                style="width: 100%"
                autocomplete="off"
                placeholder="请输入姓名"
              />
            </el-form-item>
            <el-form-item label="手机号码" prop="userPhone">
              <el-input 
                v-model="userFormData.userPhone" 
                style="width: 100%"
                :maxlength="11"
                autocomplete="off"
                placeholder="请输入手机号码"
              />
            </el-form-item>
          </el-form>
          <template #footer>
          <div class="dialog-footer">
              <el-button @click="dialogFormUser = false">取消</el-button>
              <el-button type="primary" @click="saveUser()">确定</el-button>
          </div>
          </template>
      </el-dialog>
    </template>
    
    <script>
    import { isMobile, isPhone, required, isCreditCode } from '@/utils/validators';
    export default {
    name:'Enterprise',
    data() {
      return {
        enterpriseFormRef: null,
        userFormRef: null,
        enterpriseRules: {
          entName: [required('请输入企业名称')],
          creditCode: [required('请输入统一社会信用代码'), isCreditCode()],
          legalPerson: [required('请输入法人代表')],
          billingMode: [required('请选择计费模式')],
          statistics: [required('请选择是否统计')],
          contactPhone: [required('请输入联系电话'), isPhone('请输入正确的联系电话')],
        },
        userRules: {
          name: [required('请输入姓名')],
          userPhone: [required('请输入手机号码'), isMobile('请输入正确的手机号码')],
        },
        activeState: 0,
        // 0:基本信息 1:用户列表 2:账单 3:充电记录 4:车辆列表
        detailData:{},
        enterpriseUserList:[],
        billList:[],
        tradeTime:[],
        chargeRecordList:[],
        chargeFormInline:{
          chargeRecordTime:[],
          transactionId:'',
          phoneNumber:'',
          dateType:1
        },
        userFormData:{
          name:'',
          userPhone:''
        },
        dialogFormUser:false,
        drawer:false,
        drawerTitle:'企业详情',
        formInline:{
            entName:'',
            statistics:''
        },
        typeOptions:[
          {
            label:'全部',
            value:''
          },
          {
            label:'是',
            value:1
          },
          {
            label:'否',
            value:2
          }
        ],
        billingModeOptions:[
          {
            label:'预付费',
            value:1
          },
          {
            label:'后付费',
            value:2
          },
          {
            label:'免费',
            value:3
          }
        ],
        isUpdate:false,
        dialogTitle:'添加企业',
        dialogFormVisible:false,
        currt_id:'', //当前操作id
        currt_user_id:'', //当前操作用户id
        tableData:[],
        addInfo:{
          entName:'',
          creditCode:'',
          legalPerson:'',
          billingMode:'',
          contactPhone:'',
          address:'',
        },
        total: 0, //总条数
        currentPage: 1, //当前页
        pageSize: 10, //每页显示条数
        total2: 0, //总条数
        currentPage2: 1, //当前页
        pageSize2: 10, //每页显示条数
        total3: 0, //总条数
        currentPage3: 1, //当前页
        pageSize3: 10, //每页显示条数
        total4: 0, //总条数
        currentPage4: 1, //当前页
        pageSize4: 10, //每页显示条数
        centerDialogVisible:false, //删除对话框是否显示
        unbindDialog:false, //解绑对话框是否显示
      }
    },
    components: {
      
    },
    computed: {
      filteredMessage() {
        // 这里可以实现类似过滤器的转换逻辑
      }
    },
    beforeCreate(){
      
    },
    created(){
      
    },
    mounted(){
      this.getList();
    },
    methods:{
      handleUnbind(index,row){
        //解绑用户
        this.unbindDialog = true;
        this.currt_user_id = row.id;
      },
      unbindEnterprise(){
        //解绑用户
        let param = {};
        param.entId = this.currt_id;
        param.driverUserId = this.currt_user_id;
        this.$axios.post(this.$store.state.platformApi+"enterprise/user/unbind",JSON.stringify(param)).then(result => {
          if(result.code==200){
            // 解绑成功
            this.$message({
              message: '解绑成功',
              type: 'success'
            })
            // 解绑成功后，刷新列表
            this.getEnterpriseUserList();
            this.unbindDialog = false;
          }
        })
      },
      handleClick(tab, event) {
        // console.log(tab, event);
        this.activeState = tab;
        if(this.activeState==1){
          this.getEnterpriseUserList();
        }else if(this.activeState==2){
          this.getBillList(false);
        }else if(this.activeState==3){
          this.getChargeRecordList(false);
        }
      },
      showDrawer(index,row){
        //显示抽屉
        this.currt_id = row.id;
        this.drawer = true;
        this.activeState = 0;
        this.detailData = JSON.parse(JSON.stringify(row));
      },
      addUser(){
        //添加用户
        this.dialogFormUser = true;
        this.userFormData.name = '';
        this.userFormData.userPhone = '';
      },
      saveUser(){
        //保存用户
        this.$refs.userFormRef.validate((valid) => {
          if (!valid) return;
          
          let param = {};
          param.entId = this.currt_id;
          param.name = this.userFormData.name;
          param.phoneNumber = this.userFormData.userPhone;
          this.$axios.post(this.$store.state.platformApi+"enterprise/user/bind",JSON.stringify(param)).then(result => {
            if(result.code==200){
              // 绑定成功
              this.$message({
                message: '绑定成功',
                type: 'success'
              })
              // 绑定成功后，刷新列表
              this.getEnterpriseUserList();
              this.dialogFormUser = false;
            }
          })
        });
      },
      getEnterpriseUserList(){
        //获取企业用户列表
        let that = this;
        let param = {};
        param.entId = that.currt_id;
        param.page = that.currentPage2;
        param.pageSize = that.pageSize2;

        that.$axios.post(that.$store.state.platformApi+"enterprise/user/userPage",JSON.stringify(param)).then(result => {
          if(result.code==200){
            that.enterpriseUserList = result.data.records;
            that.total2 = result.data.total;
          }
        })
      },
      getBillList(isSearch){
        //获取账单列表
        let that = this;
        let param = {};
        param.entId = that.currt_id;
        param.page = that.currentPage3;
        param.pageSize = that.pageSize3;
        if(isSearch){
          param.page = 1;
        }
        if(that.tradeTime && that.tradeTime.length==2){
          param.startTime = that.tradeTime[0];
          param.endTime = that.tradeTime[1];
        }
        that.$axios.post(that.$store.state.platformApi+"enterprise/bill",JSON.stringify(param)).then(result => {
          if(result.code==200){
            that.billList = result.data.records;
            that.total3 = result.data.total;
          }
        })
      },
      getChargeRecordList(isSearch){
        //获取充电记录列表
        let that = this;
        let param = {};
        param.entId = that.currt_id;
        param.page = that.currentPage4;
        param.pageSize = that.pageSize4;
        param.dateType = that.chargeFormInline.dateType;
        if(isSearch){
          param.page = 1;
        }
        if(that.chargeFormInline.chargeRecordTime && that.chargeFormInline.chargeRecordTime.length==2){
          param.startTime = that.chargeFormInline.chargeRecordTime[0];
          param.endTime = that.chargeFormInline.chargeRecordTime[1];
        }
        if(that.chargeFormInline.transactionId){
          param.transactionId = that.chargeFormInline.transactionId;
        }
        if(that.chargeFormInline.phoneNumber){
          param.phoneNumber = that.chargeFormInline.phoneNumber;
        }
        that.$axios.post(that.$store.state.platformApi+"enterprise/chargeRecord",JSON.stringify(param)).then(result => {
          if(result.code==200){
            that.chargeRecordList = result.data.records;
            that.total4 = result.data.total;
          }
        })
      },
      deleteEnterprise(){
        //删除
        let that = this;
        let param = {};
        param.entId = that.currt_id;
        // console.log(param);
        that.$axios.post(that.$store.state.platformApi+"enterprise/del",JSON.stringify(param)).then(result => {
          if(result.code==200){
            // 删除成功
            that.$message({
              message: '删除成功',
              type: 'success'
            })
            // 删除成功后，刷新列表
            that.getList();
            that.centerDialogVisible = false;
          }
        })
      },
      handleDelete(index,row){
        //删除
        this.currt_id = row.id;
        this.centerDialogVisible = true;
      },
      handleSizeChange (val) { //每页显示条数
          this.pageSize = val;
          this.currentPage = 1;
          this.getList();
      },
      handleCurrentChange(val) { //当前页
          this.currentPage = val;
          this.getList(); //获取列表
      },
      handleSizeChange2 (val) { //每页显示条数
          this.pageSize2 = val;
          this.currentPage2 = 1;
          this.getEnterpriseUserList();
      },
      handleCurrentChange2(val) { //当前页
          this.currentPage2 = val;
          this.getEnterpriseUserList(); //获取列表
      },
      handleSizeChange3 (val) { //每页显示条数
          this.pageSize3 = val;
          this.currentPage3 = 1;
          this.getBillList(false);
      },
      handleCurrentChange3(val) { //当前页
          this.currentPage3 = val;
          this.getBillList(false); //获取列表
      },
      handleSizeChange4 (val) { //每页显示条数
          this.pageSize4 = val;
          this.currentPage4 = 1;
          this.getChargeRecordList(false);
      },
      handleCurrentChange4(val) { //当前页
          this.currentPage4 = val;
          this.getChargeRecordList(false); //获取列表
      },
      search(){
        //搜索
        let that = this;
        let param = {};
        param.page = 1;
        param.pageSize = this.pageSize;
        param.entName = that.formInline.entName;
        param.statistics = that.formInline.statistics;

        that.$axios.post(that.$store.state.platformApi+"enterprise/page",JSON.stringify(param)).then(result => {
          if(result.code==200){
            that.tableData = result.data.records;
            that.total = result.data.total;
          }
        })
      },
      getList(){
        //获取列表
        let that = this;
        let param = {};
        param.page = this.currentPage;
        param.pageSize = this.pageSize;
        param.entName = that.formInline.entName;
        param.statistics = that.formInline.statistics;

        that.$axios.post(that.$store.state.platformApi+"enterprise/page",JSON.stringify(param)).then(result => {
          if(result.code==200){
            that.tableData = result.data.records;
            that.total = result.data.total;
          }
        })
      },
      saveInfo(){
        //保存
        let that = this;
        this.$refs.enterpriseFormRef.validate((valid) => {
          if (!valid) return;
          
          let param = {};
          if(that.isUpdate){
            //编辑
             var url = that.$store.state.platformApi+"enterprise/edit";
          }else{
              var url = that.$store.state.platformApi+"enterprise/add";
          }
          param = this.addInfo;
          // console.log(this.addInfo)
          that.$axios.post(url,JSON.stringify(param)).then(result => {
            if(result.code==200){
              // 保存成功
              that.$message({
                message: '保存成功',
                type: 'success'
              });
              that.dialogFormVisible = false;
              that.getList();
            }
          })
        });
      },
      showAdd(index,row){
        //打开添加弹窗
          this.isUpdate = false;
          this.dialogTitle = '添加企业';
          this.imgList = [];
          this.addInfo = Object.fromEntries(
            Object.keys(this.addInfo).map(key => [key, ''])
          );
          this.dialogFormVisible = true;
      },
      handleEdit(index,row){
        //打开编辑
        this.dialogTitle = '编辑企业';
        this.isUpdate = true;
        this.dialogFormVisible = true;
        this.addInfo = JSON.parse(JSON.stringify(row));
        this.currt_id = row.id;
      },
      modeFilter(value) {
        //过滤函数
        switch (value) {
          case 1:
            return '预付费';
          case 2:
            return '后付费';
          case 3:
            return '免费';
          default:
            return '其他';
        }
      },
      statisticsFilter(value) {
        //过滤函数
        switch (value) {
          case 1:
            return '是';
          case 0:
            return '否';
          default:
            return '其他';
        }
      },
    }
  }
  </script>
  
  <style lang="scss" scoped>
  .search_nav{
      width: 100%;
      height: 60px;
  }
  </style>